/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const EntityBalanceReportCreatePage = lazyLoad(
  () => import('./index'),
  module => module.EntityBalanceReportCreatePage
);
